export default "__VITE_ASSET__f2f870ec__"